<div class="flex items-center justify-center dialog-header ">
    Add Note

    <!-- <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div> -->

</div>

<div class="dialog-content">
    <div class="p-5">
        <div class="mb-2 font-medium">Enter Note</div>
        <textarea pInputTextarea class="w-full gray-input p-3" [(ngModel)]="note" rows="5"></textarea>

        <div class="flex justify-end mt-4">
            <div>
                <p-button label="Save" [loading]="isAddNoteLoading" (onClick)="saveNotes()" [disabled]="!note"
                    icon="pi pi-save"
                     class="w-full mt-4" />
            </div>
        </div>
    </div>
</div>

    